module.exports = __webpack_public_path__ + "static/media/fondotren-blur.75545ecd.jpg";